import { render, screen } from '@testing-library/react';
import Fanzine from './Fanzine';

describe('Fanzine', () => {
  test('renders fanzine cover image from local asset path', () => {
    render(
      <Fanzine
        href='https://example.com/fanzine'
        imgUrl='assets/img/fanzines/img_fanzine_cm_01.png'
      />
    );

    const cover = screen.getByRole('img', { name: /cover from the fanzine number/i });
    expect(cover.getAttribute('src')).toContain('img_fanzine_cm_01.png');
  });
});
